module.exports = __webpack_public_path__ + "static/media/animals.da042b7b.webp";